import { motion } from "framer-motion";

const WORDS = [
  "Moda circular",
  "Autoridade",
  "Desejo",
  "Segunda vida",
  "Curadoria",
  "Herida",
];

export default function Marquee() {
  const line = WORDS.join("  ✦  ");
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-brick-500 text-cream overflow-hidden py-10 sm:py-16 border-y border-brick-600"
    >
      <div className="marquee-track animate-marquee">
        {Array.from({ length: 4 }).map((_, i) => (
          <span
            key={i}
            className="font-serif italic pr-14"
            style={{ fontSize: "clamp(4rem, 12vw, 12rem)", lineHeight: 1 }}
            aria-hidden={i > 0}
          >
            {line}  ✦ 
          </span>
        ))}
      </div>
      <div className="marquee-track animate-marquee-fast opacity-30 mt-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <span
            key={i}
            className="font-mono uppercase tracking-[0.3em] text-xs sm:text-sm pr-10"
          >
            desapega · renova · transforma  ·  desde 2020  ·
          </span>
        ))}
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.4 }}
        className="mx-auto max-w-[1600px] px-6 sm:px-10 mt-8 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.3em] text-cream/70"
      >
        <span>— A boa moda não morre.</span>
        <span>Ela circula.</span>
      </motion.div>
    </section>
  );
}
